const terminalMeta = {
  displayedTitle: "Touch-Kasse", rights: ["cassa_admin"], posTerminal: true,
  hideAppBar: true, hideBottomNavigation: true, fullWidth: true,
}

export default [{
  path: "/kasse",
  name: "posTouchWorkspace",
  component: () => import(/* webpackChunkName: "pos-workspace" */ "@/views/dashboard/pos/PosWorkspace.vue"),
  meta: { ...terminalMeta },
  children: [{
    path: "", name: "posTouchSale",
    component: () => import(/* webpackChunkName: "pos-workspace" */ "@/views/dashboard/pos/PosSale.vue"),
    meta: { ...terminalMeta },
  }],
}]
